import React, { useEffect, useState } from "react";
import axios from "axios";
import "./SuperAdminPage.css";

const API_URL = process.env.REACT_APP_API_URL || "https://api.deskpos.ie";

const getAuthConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("pos_token")}`,
  },
});

const FEATURE_FIELDS = [
  { key: "enable_drs", label: "DRS" },
  { key: "enable_lottery", label: "Lottery" },
  { key: "enable_payzone", label: "Payzone" },

  {
    key: "enable_news_magz",
    label: "News / Magz Button",
  },
  {
    key: "enable_coffee",
    label: "Hot Drinks Button",
  },
  {
    key: "enable_carrier_bag",
    label: "Carrier Bag Button",
  },

  { key: "enable_grocery_button", label: "Grocery Button" },
  { key: "enable_surcharge", label: "Surcharge" },
  { key: "enable_age_check", label: "Age Check" },

  // Vape / phone shop buttons
  { key: "enable_vape_button", label: "Vape Button" },
  { key: "enable_nicotine_pouch_button", label: "Nicotine Pouch Button" },
  { key: "enable_e_liquid_button", label: "E-Liquid Button" },
  { key: "enable_vape_accessories_button", label: "Vape Accessories Button" },
  { key: "enable_pods_button", label: "Pods Button" },
  { key: "enable_phone_accessories_button", label: "Phone Accessories Button" },

  {
    key: "enable_device",
    label: "Device Sale Button",
  },

  {
  key: "enable_margin_vat",
  label: "Margin VAT Button",
},

  { key: "enable_print_scan_button", label: "Print / Scan Button" },

// Repair features
{
  key: "enable_repair_service_button",
  label: "Repair Service Button",
},
{
  key: "enable_repair_management",
  label: "Repair Management",
},


];

function SuperAdminPage() {
  const [shops, setShops] = useState([]);

  const [shopForm, setShopForm] = useState({
    shop_name: "",
    shop_type: "grocery",
    plan_name: "monthly",
    expires_at: "",
    max_tills: 1,
    admin_name: "",
    admin_email: "",
    admin_password: "",
  });

  const [licenceForm, setLicenceForm] = useState({
    shop_id: "",
    plan_name: "",
    expires_at: "",
    max_tills: "",
    status: "",
  });

  const [featureShop, setFeatureShop] = useState(null);
  const [featureForm, setFeatureForm] = useState({
    enable_drs: false,
    enable_lottery: false,
    enable_payzone: false,
    enable_grocery_button: false,
    enable_surcharge: false,
    enable_age_check: false,

    enable_vape_button: false,
    enable_nicotine_pouch_button: false,
    enable_e_liquid_button: false,
    enable_vape_accessories_button: false,
    enable_pods_button: false,
    enable_phone_accessories_button: false,
    enable_device: false,
    enable_margin_vat: false,
    enable_print_scan_button: false,
    enable_repair_service_button: false,
    enable_repair_management: false,
  });

  const [featureLoading, setFeatureLoading] = useState(false);
  const [featureSaving, setFeatureSaving] = useState(false);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const loadShops = async () => {
    try {
      setError("");
      const res = await axios.get(
        `${API_URL}/super-admin/shops`,
        getAuthConfig(),
      );
      setShops(res.data || []);
    } catch (err) {
      console.error("Load shops error:", err);
      setError(err.response?.data?.error || "Failed to load shops");
    }
  };

  useEffect(() => {
    loadShops();
  }, []);

  const createShop = async (e) => {
    e.preventDefault();

    try {
      setMessage("");
      setError("");

      const res = await axios.post(
        `${API_URL}/super-admin/shops/create-full`,
        shopForm,
        getAuthConfig(),
      );

      setShopForm({
        shop_name: "",
        shop_type: "grocery",
        plan_name: "monthly",
        expires_at: "",
        max_tills: 1,
        admin_name: "",
        admin_email: "",
        admin_password: "",
      });

      setMessage(
        `Shop created successfully. Admin login email: ${res.data.login_details.email}`,
      );

      loadShops();
    } catch (err) {
      console.error("Create shop error:", err);
      setError(err.response?.data?.error || "Failed to create shop");
    }
  };

  const resetAdminPassword = async (shop) => {
    if (!shop.admin_user_id) {
      setError("No admin user found for this shop");
      return;
    }

    const newPassword = window.prompt(
      `Enter new password for ${shop.admin_email || shop.name}:`,
    );

    if (!newPassword) return;

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    const confirmReset = window.confirm(
      `Are you sure you want to reset password for ${shop.admin_email}?`,
    );

    if (!confirmReset) return;

    try {
      setMessage("");
      setError("");

      const res = await axios.put(
        `${API_URL}/super-admin/users/${shop.admin_user_id}/reset-password`,
        {
          new_password: newPassword,
        },
        getAuthConfig(),
      );

      setMessage(res.data.message || "Password reset successfully");

      setTimeout(() => {
        setMessage("");
      }, 2500);
    } catch (err) {
      console.error("Reset password error:", err.response?.data || err.message);

      setError(
        err.response?.data?.error || err.message || "Failed to reset password",
      );
    }
  };

  const handleLicenceShopChange = (e) => {
    const shopId = e.target.value;

    if (!shopId) {
      setLicenceForm({
        shop_id: "",
        plan_name: "",
        expires_at: "",
        max_tills: "",
        status: "",
      });

      return;
    }

    const selectedShop = shops.find(
      (shop) => String(shop.id) === String(shopId),
    );

    if (!selectedShop) {
      return;
    }

    let expiryDate = "";

    if (selectedShop.expires_at) {
      const date = new Date(selectedShop.expires_at);

      if (!Number.isNaN(date.getTime())) {
        expiryDate = date.toISOString().split("T")[0];
      }
    }

    setLicenceForm({
      shop_id: String(selectedShop.id),
      plan_name: selectedShop.plan_name || "",
      expires_at: expiryDate,
      max_tills: selectedShop.max_tills ?? "",
      status: selectedShop.license_status || "",
    });
  };

  const createLicence = async (e) => {
    e.preventDefault();

    try {
      setMessage("");
      setError("");

      const res = await axios.post(
        `${API_URL}/super-admin/licenses`,
        licenceForm,
        getAuthConfig(),
      );

      setMessage(res.data.message || "Licence updated successfully");

      setLicenceForm({
        shop_id: "",
        plan_name: "",
        expires_at: "",
        max_tills: "",
        status: "",
      });

      loadShops();
    } catch (err) {
      console.error("Licence update error:", err.response?.data || err.message);

      setError(
        err.response?.data?.error || err.message || "Failed to update licence",
      );
    }
  };

  const deleteShop = async (shop) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${shop.name}"?\n\nThis will disable the shop and suspend its licence. Sales data will stay safe.`,
    );

    if (!confirmDelete) return;

    const secondConfirm = window.confirm(
      `Final confirmation:\n\nDelete shop #${shop.id} - ${shop.name}?`,
    );

    if (!secondConfirm) return;

    try {
      setMessage("");
      setError("");

      const res = await axios.delete(
        `${API_URL}/super-admin/shops/${shop.id}`,
        getAuthConfig(),
      );

      setMessage(res.data.message || "Shop deleted successfully");

      setShops((prev) => prev.filter((s) => s.id !== shop.id));

      setTimeout(() => {
        setMessage("");
      }, 2500);
    } catch (err) {
      console.error("Delete shop error:", err.response?.data || err.message);

      setError(
        err.response?.data?.error || err.message || "Failed to delete shop",
      );
    }
  };

  const openFeatureManager = async (shop) => {
    try {
      setMessage("");
      setError("");
      setFeatureLoading(true);
      setFeatureShop(shop);

      const res = await axios.get(
        `${API_URL}/super-admin/shops/${shop.id}/features`,
        getAuthConfig(),
      );

      const defaultFeatureForm = FEATURE_FIELDS.reduce((acc, feature) => {
        acc[feature.key] = false;
        return acc;
      }, {});

      setFeatureForm({
        ...defaultFeatureForm,
        ...res.data,
      });
    } catch (err) {
      console.error("Load features error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "Failed to load shop features");
    } finally {
      setFeatureLoading(false);
    }
  };

  const closeFeatureManager = () => {
    setFeatureShop(null);
    setFeatureLoading(false);
    setFeatureSaving(false);
  };

  const saveFeatures = async () => {
    if (!featureShop) return;

    try {
      setMessage("");
      setError("");
      setFeatureSaving(true);

      const payload = FEATURE_FIELDS.reduce((acc, feature) => {
        acc[feature.key] = !!featureForm[feature.key];
        return acc;
      }, {});

      const res = await axios.put(
        `${API_URL}/super-admin/shops/${featureShop.id}/features`,
        payload,
        getAuthConfig(),
      );

      setMessage(res.data.message || "Shop features updated successfully");

      setTimeout(() => {
        setMessage("");
      }, 2500);

      closeFeatureManager();
    } catch (err) {
      console.error("Save features error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "Failed to save shop features");
    } finally {
      setFeatureSaving(false);
    }
  };

  return (
    <div className="super-admin-page">
      <div className="super-admin-header">
        <div>
          <h1 style={{ color: "#FFF" }}>Super Admin</h1>
          <p>Create shops, licences and manage customer accounts.</p>
        </div>
      </div>

      {message && <div className="super-message">{message}</div>}
      {error && <div className="super-error">{error}</div>}

      <div className="super-grid">
        <div className="super-card">
          <h2>Create Shop</h2>

          <form onSubmit={createShop} className="super-form">
            <label>
              Shop Name
              <input
                type="text"
                value={shopForm.shop_name}
                onChange={(e) =>
                  setShopForm({ ...shopForm, shop_name: e.target.value })
                }
                placeholder="Example: Nearby Store"
              />
            </label>

            <label>
              Shop Type
              <select
                value={shopForm.shop_type}
                onChange={(e) =>
                  setShopForm({ ...shopForm, shop_type: e.target.value })
                }
              >
                <option value="grocery">Grocery</option>
                <option value="vape">Vape Shop</option>
                <option value="off_licence">Off Licence</option>
                <option value="takeaway">Takeaway</option>
              </select>
            </label>

            <label>
              Licence Plan
              <select
                value={shopForm.plan_name}
                onChange={(e) =>
                  setShopForm({ ...shopForm, plan_name: e.target.value })
                }
              >
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
                <option value="trial">Trial</option>
              </select>
            </label>

            <label>
              Licence Expiry Date
              <input
                type="date"
                value={shopForm.expires_at}
                onChange={(e) =>
                  setShopForm({ ...shopForm, expires_at: e.target.value })
                }
              />
            </label>

            <label>
              Max Tills
              <input
                type="number"
                min="1"
                value={shopForm.max_tills}
                onChange={(e) =>
                  setShopForm({ ...shopForm, max_tills: e.target.value })
                }
              />
            </label>

            <label>
              Admin Name
              <input
                type="text"
                value={shopForm.admin_name}
                onChange={(e) =>
                  setShopForm({ ...shopForm, admin_name: e.target.value })
                }
                placeholder="Example: John Manager"
              />
            </label>

            <label>
              Admin Email
              <input
                type="email"
                value={shopForm.admin_email}
                onChange={(e) =>
                  setShopForm({ ...shopForm, admin_email: e.target.value })
                }
                placeholder="admin@shop.com"
              />
            </label>

            <label>
              Admin Password
              <input
                type="password"
                value={shopForm.admin_password}
                onChange={(e) =>
                  setShopForm({ ...shopForm, admin_password: e.target.value })
                }
                placeholder="Password for shop admin"
              />
            </label>

            <button type="submit">Create Shop + Admin</button>
          </form>
        </div>

        <div className="super-card">
          <h2>Renew / Update Licence</h2>

          <form onSubmit={createLicence} className="super-form">
            <label>
              Select Shop
              <select
                value={licenceForm.shop_id}
                onChange={handleLicenceShopChange}
              >
                <option value="">Select shop</option>
                {shops.map((shop) => (
                  <option key={shop.id} value={shop.id}>
                    #{shop.id} - {shop.name}
                  </option>
                ))}
              </select>
            </label>

            <label>
              Plan
              <select
                value={licenceForm.plan_name}
                disabled={!licenceForm.shop_id}
                onChange={(e) =>
                  setLicenceForm({
                    ...licenceForm,
                    plan_name: e.target.value,
                  })
                }
              >
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
                <option value="trial">Trial</option>
                <option value="standard">Standard</option>
                <option value="pro">Pro</option>
                <option value="enterprise">Enterprise</option>
              </select>
            </label>

            <label>
              Status
              <select
                value={licenceForm.status}
                disabled={!licenceForm.shop_id}
                onChange={(e) =>
                  setLicenceForm({
                    ...licenceForm,
                    status: e.target.value,
                  })
                }
              >
                <option value="active">Active</option>
                <option value="suspended">Suspended</option>
                <option value="expired">Expired</option>
              </select>
            </label>

            <label>
              Expiry Date
              <input
                type="date"
                value={licenceForm.expires_at}
                disabled={!licenceForm.shop_id}
                onChange={(e) =>
                  setLicenceForm({
                    ...licenceForm,
                    expires_at: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Max Tills
              <input
                type="number"
                min="1"
                value={licenceForm.max_tills}
                disabled={!licenceForm.shop_id}
                onChange={(e) =>
                  setLicenceForm({
                    ...licenceForm,
                    max_tills: e.target.value,
                  })
                }
              />
            </label>

            <button type="submit" disabled={!licenceForm.shop_id}>
              Update Licence
            </button>
          </form>
        </div>
      </div>

      <div className="super-card shops-list-card">
        <h2>All Shops</h2>

        <div className="super-table-wrap">
          <table className="super-table">
            <thead>
              <tr>
                <th>Shop ID</th>
                <th>Shop Name</th>
                <th>Type</th>
                <th>Admin Email</th>
                <th>Active</th>
                <th>Licence Key</th>
                <th>Plan</th>
                <th>Licence Status</th>
                <th>Expiry</th>
                <th>Max Tills</th>
                <th>Features</th>
                <th>Password</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {shops.length === 0 ? (
                <tr>
                  <td colSpan="13" className="no-shops">
                    No shops found.
                  </td>
                </tr>
              ) : (
                shops.map((shop) => (
                  <tr key={shop.id}>
                    <td>#{shop.id}</td>
                    <td>{shop.name}</td>
                    <td>{shop.type}</td>
                    <td>{shop.admin_email || "No admin"}</td>
                    <td>{shop.is_active ? "Yes" : "No"}</td>
                    <td>{shop.license_key || "-"}</td>
                    <td>{shop.plan_name || "-"}</td>
                    <td>{shop.license_status || "-"}</td>
                    <td>
                      {shop.expires_at
                        ? new Date(shop.expires_at).toLocaleDateString()
                        : "-"}
                    </td>
                    <td>{shop.max_tills || "-"}</td>
                    <td>
                      <button
                        type="button"
                        className="super-feature-btn"
                        onClick={() => openFeatureManager(shop)}
                      >
                        Manage
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="super-reset-password-btn"
                        onClick={() => resetAdminPassword(shop)}
                        disabled={!shop.admin_user_id}
                      >
                        Reset
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="super-delete-shop-btn"
                        onClick={() => deleteShop(shop)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {featureShop && (
        <div className="super-modal-backdrop">
          <div className="super-modal">
            <div className="super-modal-header">
              <div>
                <h2>Manage Features</h2>
                <p>
                  #{featureShop.id} - {featureShop.name}
                </p>
              </div>

              <button
                type="button"
                className="super-modal-close"
                onClick={closeFeatureManager}
              >
                ×
              </button>
            </div>

            {featureLoading ? (
              <p>Loading features...</p>
            ) : (
              <div className="super-feature-grid">
                {FEATURE_FIELDS.map((feature) => (
                  <label key={feature.key} className="super-feature-toggle">
                    <input
                      type="checkbox"
                      checked={!!featureForm[feature.key]}
                      onChange={(e) =>
                        setFeatureForm((prev) => ({
                          ...prev,
                          [feature.key]: e.target.checked,
                        }))
                      }
                    />
                    <span>{feature.label}</span>
                  </label>
                ))}
              </div>
            )}

            <div className="super-modal-actions">
              <button type="button" onClick={closeFeatureManager}>
                Cancel
              </button>

              <button
                type="button"
                onClick={saveFeatures}
                disabled={featureSaving || featureLoading}
              >
                {featureSaving ? "Saving..." : "Save Features"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuperAdminPage;
